export const FETCH_ADMIN_STATS_REQUEST = 'FETCH_ADMIN_STATS_REQUEST';
export const FETCH_ADMIN_STATS_SUCCESS = 'FETCH_ADMIN_STATS_SUCCESS';
export const FETCH_ADMIN_STATS_FAILURE = 'FETCH_ADMIN_STATS_FAILURE';
export const FETCH_RECENT_ACTIVITIES_REQUEST = 'FETCH_RECENT_ACTIVITIES_REQUEST';
export const FETCH_RECENT_ACTIVITIES_SUCCESS = 'FETCH_RECENT_ACTIVITIES_SUCCESS';
export const FETCH_RECENT_ACTIVITIES_FAILURE = 'FETCH_RECENT_ACTIVITIES_FAILURE';